import { render, staticRenderFns } from "./LoadingPanel.vue?vue&type=template&id=06783559&"
import script from "./LoadingPanel.vue?vue&type=script&lang=js&"
export * from "./LoadingPanel.vue?vue&type=script&lang=js&"
import style0 from "./LoadingPanel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports